import { startCase, toLower } from 'lodash-es';

export function toTitleCase(str: string): string {
  return startCase(toLower(str));
}

export function toBoolean(str?: string | boolean): boolean | undefined {
  // If it's already a boolean, return it directly
  if (typeof str === 'boolean') return str;
  // If it's a string, convert it
  if (typeof str === 'string') {
    if (str.toLowerCase() === 'true') return true;
    if (str.toLowerCase() === 'false') return false;
  }
  return undefined;
}

export const stringToRegExp = (str: string, flags?: string): RegExp =>
  RegExp(str.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1'), flags);
